import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ShowcaseService } from '@pages/dashboard/services/showcase.service';
import { IShowcase } from '@pages/dashboard/models/showcase.model';
import { environment } from '@environments/environment';

const RECOMMENDED_ITEMS_LIMIT = 5;

@Component({
  selector: 'app-cart-skuba-recommends',
  templateUrl: './cart-skuba-recommends.component.html',
  styleUrls: ['./cart-skuba-recommends.component.scss']
})
export class CartSkubaRecommendsComponent implements OnInit, OnDestroy {
  items: IShowcase[] = [];
  base_url = environment.api_url;

  private itemsSub: Subscription;

  constructor(private showcaseService: ShowcaseService) {}

  ngOnInit() {
    this.itemsSub = this.showcaseService.getShowcases({ placement: '1' }).subscribe(data => {
      this.items = data.slice(0, RECOMMENDED_ITEMS_LIMIT).map(item => {
        const picturePath = (item as any).active_picture_url || item.picture_url;
        const picture_url = picturePath
          ? `${this.base_url}${picturePath}?width=350&quality=80`
          : '';

        return {
          ...item,
          picture_url,
          showRealPicture: false
        };
      });
    });
  }

  imageLoaded(image: IShowcase) {
    image.showRealPicture = true;
  }

  saveDashboardClick(id: number) {
    if (!id) {
      return;
    }
    this.showcaseService.postDashboardClick(id).subscribe();
  }

  ngOnDestroy() {
    if (this.itemsSub) {
      this.itemsSub.unsubscribe();
    }
  }
}
